/**
 * @file 类型转换
 * @module to.js
 * @author wangyongqing <wangyongqing01@baidu.com>
 */
import {isNil, isString} from './is';
/**
 * 将传入的对象转换成数组
 * @function toArray
 * @param {any} arrayLike - 被转对象
 * @return {array} 返回array
 */
export function toArray(arrayLike) {
    return [].slice.call(arrayLike);
}
/**
 * 将传入的对象转换成数字
 * @function toNumber
 * @param {any} value - 被转对象
 * @param { any} [defaultValue=null] - 如果不能转，默认返回值
 * @return {Number} 返回number
 */
export function toNumber(value, defaultValue = null) {
    if (isNil(value)) {
        return defaultValue;
    }

    return Number(value);
}
/**
 * 将传入的对象返回布尔
 * @function toBoolean
 * @param {any} value - 被转对象
 * @param { any} [defaultValue=null] - 如果不能转，默认返回值
 * @return {Boolean} 返回boolean
 */
export function toBoolean(value, defaultValue = false) {
    if (isNil(value)) {
        return defaultValue;
    }

    return Boolean(value);
}
/**
 * 将传入对象返回字符串
 * @function toString
 * @param {any} value - 被转对象
 * @param { any} [defaultValue=null] - 如果不能转，默认返回值
 * @return {string} 返回字符串
 */
export function toString(value, defaultValue = null) {
    if (isNil(value)) {
        return defaultValue;
    }

    if (isString(value)) {
        return value;
    }

    return String(value);
}
